import { ShieldCheck, Users, Wrench, ThumbsUp, CheckCircle2 } from "lucide-react";

const TRUST_IMG =
  "https://images.unsplash.com/photo-1686771416282-3888ddaf249b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1lZXRpbmclMjBoYW5kc2hha2UlMjBmYWNpbGl0eXxlbnwwfHx8fDE3ODI3NjA1MDF8MA&ixlib=rb-4.1.0&q=85";

const POINTS = [
  { icon: ShieldCheck, title: "Licensed & Insured", text: "Fully credentialed across every trade we perform, including high & low voltage electrical." },
  { icon: Users, title: "One Accountable Team", text: "No juggling subcontractors — we coordinate the whole job from demo to finish." },
  { icon: Wrench, title: "Done Right, to Code & on Time", text: "Workmanship that passes inspection and holds up for years to come." },
  { icon: ThumbsUp, title: "Quality in the Details", text: "Our reputation lives in the finish work most companies overlook." },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-20 lg:py-28" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-200">
              <img src={TRUST_IMG} alt="Professional commercial service" className="w-full h-[480px] object-cover" />
            </div>
          </div>

          <div>
            <p className="text-sm uppercase tracking-widest text-accent font-semibold mb-3">Why Prowess</p>
            <h2 className="text-3xl md:text-4xl font-display font-bold tracking-tight text-slate-900">
              The Reliable Partner for Commercial Property Work
            </h2>
            <p className="mt-4 text-slate-600 text-lg">
              From a single repair to a full buildout, we bring the crew, the credentials and the
              attention to detail that keep your facility running.
            </p>

            <div className="mt-8 grid sm:grid-cols-2 gap-6">
              {POINTS.map((p) => {
                const Icon = p.icon;
                return (
                  <div key={p.title} className="flex gap-4" data-testid={`trust-point-${p.title.toLowerCase().replace(/\s|&/g, "-")}`}>
                    <div className="shrink-0 h-11 w-11 rounded-lg bg-blue-50 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-accent" strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className="font-display font-semibold text-slate-900">{p.title}</h3>
                      <p className="text-sm text-slate-500 mt-1 leading-relaxed">{p.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2">
              {["Low Cost Estimates", "Emergency Service", "Lifetime Labor Warranty", "Commercial & Residential"].map((b) => (
                <span key={b} className="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <CheckCircle2 className="h-4 w-4 text-accent" /> {b}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
